<template>
  <div class="box">
    <div class="content">
      <h3 class="title">关注微信公众号，实时接收打印消息推送</h3>
      <div class="-margin">
        <van-steps direction="vertical" :active="-1">
          <van-step>
            <span class="badge" slot="inactive-icon">1</span>
            <h3>打开微信，点开搜索栏</h3>
            <PreViewImage class="img620" :src="require('img/follow/1.png')" />
          </van-step>
          <van-step>
            <span class="badge" slot="inactive-icon">2</span>
            <h3>输入“福昕智慧打印”，点击进入公众号</h3>
            <PreViewImage class="img620" :src="require('img/follow/22.png')" />
          </van-step>
          <van-step>
            <span class="badge" slot="inactive-icon">3</span>
            <h3>点击关注“福昕智慧打印”公众号</h3>
            <PreViewImage class="img620" :src="require('img/follow/3.png')" />
          </van-step>
          <van-step>
            <span class="badge" slot="inactive-icon">4</span>
            <h3>微信公众号实时进行打印消息推送</h3>
            <PreViewImage class="img620" :src="require('img/follow/4.png')" />
          </van-step>
        </van-steps>
      </div>
    </div>
    <div class="btnBox">
      <div class="btn" @click="copyKeyword">点击复制公众号</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import PreViewImage from "common/components/app/PreViewImage.vue";

export default {
  components: {
    PreViewImage
  },
  methods: {
    copyKeyword() {
      let result;
      // 将复制内容添加到临时textarea元素中
      const tempTextarea = document.createElement("textarea");
      document.body.appendChild(tempTextarea);
      tempTextarea.value = "福昕智慧打印";
      // 判断设备
      const u = navigator.userAgent;
      if (u.match(/(iPhone|iPod|iPad);?/i)) {
        // iOS
        // 移除已选择的元素
        window.getSelection().removeAllRanges();
        // 创建一个Range对象
        const range = document.createRange();
        // 选中
        range.selectNode(tempTextarea);
        // 执行选中元素
        window.getSelection().addRange(range);
        // 复制
        result = document.execCommand("copy");
        // 移除选中元素
        window.getSelection().removeAllRanges();
      } else {
        // 选中
        tempTextarea.select();
        // 复制
        result = document.execCommand("Copy");
      }
      // 移除临时文本域
      document.body.removeChild(tempTextarea);
      if (result) {
        Dialog({
          title: "提示",
          message: "复制成功，请打开“微信”进行黏贴搜索"
        });
      } else {
        Dialog({ title: "错误", message: "该浏览器不支持复制" });
      }
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
}

.-margin {
  margin-left: -14px;
  ::v-deep .van-step {
    &::after {
      border: none;
    }
  }
  ::v-deep .van-step__title {
    h3 {
      padding-left: 6px;
      font-size: 28px;
      color: #333333;
      letter-spacing: 1px;
    }
  }
}

.badge {
  display: block;
  width: 40px;
  height: 40px;
  background-color: #0078ff;
  color: white;
  font-size: 28px;
  text-align: center;
  line-height: 40px;
  border-radius: 20px;
}

.content {
  flex: auto;
  height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 32px 0 80px 40px;
  &::-webkit-scrollbar {
    display: none;
  }
  .title {
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 51px;
    letter-spacing: 2px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 50px;
  }
}

.img620 {
  width: 620px;
  margin-top: 39px;
  margin-left: 8px;
}

.btnBox {
  height: 180px;
  padding: 0 40px;
  .btn {
    font-family: Microsoft Ya Hei;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #ffffff;
    width: 670px;
    height: 90px;
    line-height: 90px;
    text-align: center;
    background-color: #0078ff;
    border-radius: 4px;
    &:active {
      background-color: #006ce7;
    }
  }
}
</style>
